<template>
  <default-layout>
    <section class="error--page py-5">
      <div class="error-container">
        <div class="text-center mb-5">
          <div class="title--text">{{ $t('errorPage.generalErrorTitle') }}</div>
          <div class="subtitle">{{ $t('errorPage.generalErrorSubtitleFirst') }}</div>
          <div class="subtitle">
            {{ $t('errorPage.generalErrorSubtitleSecond') }}
            <a :href="`mailto:${$t('errorPage.errorContact')}`">{{
              $t('errorPage.errorContact')
            }}</a>
          </div>
        </div>
        <img
          width="300"
          src="https://s3-ap-southeast-1.amazonaws.com/rentfix/static/img/icon/error.svg"
          class="error-image"
        />
      </div>
    </section>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';

export default {
  components: { DefaultLayout },
};
</script>

<style lang="scss" scoped></style>
